import FTSAutomationNodeSequence from "../design/automation/FTSAutomationNodeSequence.vue";
import FTSAutomationNodeIfElse from "../design/automation/FTSAutomationNodeIfElse.vue";
import FTSAutomationNodeForEach from "../design/automation/FTSAutomationNodeForEach.vue";
import FTSAutomationNodeStart from "../design/automation/FTSAutomationNodeStart.vue";
import Vue from 'vue'

var actionSelections = [
    {
        id: "setVariable",
        name: "Create",
        description: "Create a new Variable",
        variable: true,
        form: [
            { id: "name", name: "Name", type: "contenteditable", required: true },
            { id: "value", fieldName: 'value', name: "Value", type: "formula" },
        ],
    },
    {
        id: "assign",
        name: "Set",
        description: "Set value to a Variable",
        form: [
            { id: "variable", name: "Variable", type: "field", required: true },
            { id: "value", name: "Value", type: "formula", expandable: true },
        ],
    },

    {
        id: "find",
        name: "Find",
        description: "Find an entry that meets condition",
        variable: true,
        form: [
            { id: "name", name: "Name", type: "contenteditable", required: true },
            { id: "moduleId", name: "Module", type: "module", required: true },
            { id: "condition", name: "Condition", type: "filter" },
        ],
    },
    {
        id: "findAll",
        name: "Find All",
        description: "Find all entries that meet condition",
        variable: true,
        form: [
            { id: "name", name: "Name", type: "contenteditable", required: true },
            { id: "moduleId", name: "Module", type: "module", required: true },
            { id: "condition", name: "Condition", type: "filter" },
        ],
    },
    {
        id: "getForm",
        name: "Form",
        description: "Retrieve a form for an activity",
        variable: true,
        form: [
            { id: "name", name: "Name", type: "contenteditable", required: true },
            { id: "moduleId", name: "Module", type: "module", required: true },
            { id: "activityId", name: "Activity", type: "activity", required: true },        
        ],
    },
    {
        id: "doActivity",
        name: "Do",
        description: "Do an activity",
        variable: true,
        form: [
            { id: "name", name: "Name", type: "contenteditable", required: true },
            { id: "moduleId", name: "Module", type: "module", required: true },
            { id: "activityId", name: "Activity", type: "activity", required: true },
            { id: "form", name: "Form", type: "form", expandable: true },
        ],
    },
    {
        id: "exception",
        name: "Error",
        description: "Show error",
        form: [{ id: "message", name: "Message", type: "formula", required: true }],
    },
];

var registerNodes = function (editor) {
    editor.registerNode(
        "start",
        FTSAutomationNodeStart,
        {
            // formula: vm.content,
            // information: vm.information,
        },
        {
            input: function (event) { },
        },
        {}
    );

    editor.registerNode(
        "ifElse",
        FTSAutomationNodeIfElse,
        {
            // formula: vm.content,
            // information: vm.information,
        },
        {
            input: function (event) { },
        },
        {}
    );

    editor.registerNode(
        "sequence",
        FTSAutomationNodeSequence,
        {
            // formula: vm.content,
            // information: vm.information,
        },
        {
            input: function (event) { },
        },
        {}
    );

    editor.registerNode(
        "forEach",
        FTSAutomationNodeForEach,
        {
            // formula: vm.content,
            // information: vm.information,
        },
        {
            input: function (event) { },
        },
        {}
    );
}

var addNode = function (editor, type, data, posX, posY) {
    switch (type) {
        case 'start':
            editor.addNode(
                type,
                0,
                1,
                posX,
                posY,
                "start",
                data,
                "start",
                "vue"
            );
            break;

        case 'ifElse':
            editor.addNode(
                type,
                1,
                2,
                posX,
                posY,
                "if-else",
                data,
                "ifElse",
                "vue"
            );
            break;

        case 'sequence':
            editor.addNode(
                type,
                1,
                1,
                posX,
                posY,
                "sequence",
                data,
                "sequence",
                "vue"
            );
            break;

        case 'forEach':
            editor.addNode(
                type,
                1,
                2,
                posX,
                posY,
                "for-each",
                data,
                "forEach",
                "vue"
            );
            break;
    }
}

var computeVariables = function (diagram) {
    Object.entries(diagram).forEach(node => {
        if (node[1].name != 'start') {
            delete node[1].data.variables;
        }
    });

    Object.entries(diagram).forEach(node => {
        computeVariablesInternally(diagram, node[1]);
    });
}

var computeVariablesInternally = function (diagram, node) {
    if (node.data && node.data.variables) {
        return node.data.variables;
    }

    let result = [];

    //internal
    if (node.name == 'start') {
        return node.data.variables;
    }

    if (node.inputs.input_1 && node.inputs.input_1.connections) {
        node.inputs.input_1.connections.forEach(inputNodeData => {
            let inputNode = diagram[inputNodeData.node];
            var vars = computeVariablesInternally(diagram, inputNode);

            //list find all
            //table

            if (inputNode.name == 'forEach' && inputNode.data.item
                && !vars.find(x => x.id == inputNode.data.item)) {
                vars.push({
                    id: inputNode.data.item,
                    name: inputNode.data.item, 
                    fieldName: inputNode.data.itemFieldName,
                    nodeId: inputNode.id,
                    type: inputNode.data.variableType,
                    moduleId: inputNode.data.moduleId,
                    informationId: inputNode.data.informationId
                });
            }

            //console.log(`bfv${node.id}:${inputNode.id} ${vars.map(x => x.name)}`);
            result = result.concat(vars);
        });
    }
    //console.log(`---${result.map(x => x.name)}`);
    Vue.set(node.data, 'variables', result);

    if (node.name == 'sequence') {
        Vue.set(node.data, 'priorVariables', result);

        if (node.data.actions) {
            let priors = node.data.actions
                .filter((x) => actionSelections.find(y => y.id == x.type).variable)
                .map(function (x) {
                    return {
                        id: x.id,
                        fieldName: x.fieldName,
                        name: x.name,
                        nodeId: node.id,
                        moduleId: x.module? x.module : x.moduleId, 
                        activityId: x.activityId,
                        informationId: x.informationId,
                        isList: x.isList || x.type == 'findAll',
                        isGroup: x.isGroup,
                        type: x.variableType
                    }
                });

            //todo: filter same
            Vue.set(node.data, 'variables', [...result, ...priors]);
        }
    }

    return node.data.variables;
}

var prepareVariables = function (information) {
    let informationPart = information.map(function (x) {
        return {
            fieldName: x.fieldName,
            type: x.type,
            name: x.displayName,
            moduleId: x.connectionId ? x.connectionId.toString() : null
        }
    })

    let systemPart = [
        {
            fieldName: 'createdDate',
            name: 'Created Date',
            system: true,
        }
    ]

    let constants = [
        // {
        //     fieldName: 'today',
        //     name: 'Today',
        //     constant: true,
        // },
        // {
        //     fieldName: 'tomorrow',
        //     name: 'Tomorrow',
        //     constant: true,
        // }
    ]

    return [...systemPart, ...informationPart, ...constants];
}

export default {
    registerNodes: registerNodes,
    addNode: addNode,
    computeVariables: computeVariables,
    actionSelections: actionSelections,
    prepareVariables: prepareVariables
}